<!--
 * @Description:首页 待办 学期教学计划
 * @Author: Xyyyyyy
 * @Date: 2023-10-09 10:43:28
 * @LastEditors: PF
 * @LastEditTime: 2024-10-09 11:12:59
-->

<template>
  <!-- <h1>学期教学计划列表</h1> -->
  <div class="tan-chuang">
    <div class="list-page">
      <el-dialog class="wp90 h800" :model-value="openJiaoXueJiHua" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Edit />
            </el-icon>
            <span class="header-title">学期教学计划</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="closeWindow('openJiaoXueJiHua', emits, false)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-container>
          <el-header>
            <!-- 搜索区域 -->
            <el-form class="search-box" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="班级" v-model="bjid" filterable @change="keChengChange">
                  <el-option v-for="item in bjData" :key="item.bjid" :label="item.bjmc" :value="item.bjid"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="课程" v-model="kcid" filterable @change="bindTable()">
                  <el-option v-for="item in kcData" :key="item.id" :label="item.kcmc" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main>
            <el-table :data="tableData" height="100%" border stripe v-loading="loading">
              <el-table-column label="顺序" prop="sx" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="周次" prop="zc" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>第{{scope.row.zc}}周</span>
                </template>
              </el-table-column>
              <el-table-column label="日期" prop="rq" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="星期" prop="xq" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>星期{{scope.row.xq}}</span>
                </template>
              </el-table-column>
              <el-table-column label="节次" prop="jc" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>第{{scope.row.jc}}节</span>
                </template>
              </el-table-column>
              <el-table-column label="场地" prop="jxcdmc" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="教学内容" header-align="center" prop="" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in neirongList" :key="index">
                 <span v-if="index === scope.$index && item.jxnrid!==null">{{item.jxnrbt}}</span>
                 <span v-if="index === scope.$index && item.jxnrid === null" >{{item.qtjxnr}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="260" fixed="right" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-button link type="success" @click="xiangShangChaRu(scope.row,scope.$index);row=scope.row">插入教学内容</el-button>
                  <el-button link type="warning" @click="delJxnr(scope.row,scope.$index)">删除教学内容</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-container>
        <template #footer>
          <div class="dialog-footer">
            <div></div>
            <div class="footer_but">
              <el-button type="primary" @click="submit()">保存</el-button>
              <el-button type="primary" @click="submitFormTj()">提交</el-button>
              <el-button type="info" @click="closeWindow('openJiaoXueJiHua', emits, false)">关闭</el-button>
            </div>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="jxnrReturnData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { actionPost, loadSelect, closeWindow } from '@/api/common.js'
import { getZwxq } from '@/utils/meiju'
import { successPrompt, warningPrompt } from '@/utils/promptInfo'
import edit from './edit.vue'

const props = defineProps({
  openJiaoXueJiHua: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openJiaoXueJiHua', 'ReturnData'])

const row = ref()

// 插入教学内容
const openEdit = ref(false)
const loc = ref()
const neirongList = ref()
const xiangShangChaRu = (val, ind) => {
  openEdit.value = true
  loc.value = ind
}
const jxnrReturnData = (data) => {
  // step2：插入时在内容列表的相应位置插入一条数据，
  neirongList.value.splice(loc.value, 0, {})
  neirongList.value[loc.value].jxnrbt = data.jxnrbt
  neirongList.value[loc.value].jxnrid = data.id
  neirongList.value[loc.value].qtjxnr = data.qtjxnr
}
// 删除教学内容
const delJxnr = (val, ind) => {
  neirongList.value.splice(ind, 1)
}

const bjid = ref()
const bjData = ref([])
// 获取班级
const initBanJi = () => {
  loadSelect({
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/jiaoshixueqikebiaobanjikecheng',
    parms: { dbgzid: parms.value.dbgzid },
    data: bjData,
    loadSuccess: function (res) {
      if (res.data) {
        bjid.value = res.data[0].bjid
        keChengChange(bjid.value)
      }
    }
  })
}
// 获取课程
const kcid = ref()
const kcData = ref([])
const keChengChange = (val) => {
  const data = bjData.value.find(item => item.bjid === val)
  kcData.value = data.listKeCheng
  kcid.value = kcData.value[0].id
  bindTable()
}

// 列表
const loading = ref(false)
const tableData = ref([])
const gudingList = ref() // 列表拆分出来的固定列表
const bindTable = async () => {
  loading.value = true
  const o = {
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/jiaoshixueqijiaoxuejihuakebiao',
    data: { dbgzid: parms.value.dbgzid, kcid: kcid.value, bjid: bjid.value }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      // step1: 调取列表后把列表拆分:内容放入一个单独的列表，固定项目放入一个单独的列表
      // 固定列表
      gudingList.value = res.data.map((item) => ({
        id: item.id,
        jc: item.jc,
        rq: item.rq,
        sx: item.sx,
        xq: item.xq,
        zc: item.zc,
        xqid: item.xqid,
        bjid: item.bjid,
        jsid: item.jsid,
        kcid: item.kcid,
        qtjxnr: item.qtjxnr,
        jxcdid: item.jxcdid,
        jxcdmc: item.jxcdmc,
        jxdyid: item.jxdyid
      }))

      // 内容列表
      neirongList.value = res.data.map((item) => ({
        jxnrbt: item.jxnrbt,
        jxnrid: item.jxnrid,
        qtjxnr: item.qtjxnr
      }))

      // 星期
      res.data.forEach((element) => {
        element.xq = getZwxq(element.xq)
      })
      tableData.value = res.data
      loading.value = false
    } else {
      loading.value = false
      warningPrompt(res.message)
    }
  })
}
const parms = ref({})
watch(
  () => props.openJiaoXueJiHua,
  () => {
    if (props.openJiaoXueJiHua) {
      parms.value = props.row
      initBanJi()
    }
  },
  { deep: true, immediate: true }
)

// 保存
const submit = async () => {
  // step3: 两个数组嵌套循环，根据相同的index生成一个新的数组
  const arr = []
  neirongList.value.forEach((e, i) => {
    gudingList.value.forEach((item, ind) => {
      if (i === ind) {
        arr.push({
          id: item.id,
          jc: item.jc,
          rq: item.rq,
          sx: item.sx,
          xq: item.xq,
          zc: item.zc,
          xqid: item.xqid,
          bjid: item.bjid,
          kcid: item.kcid,
          jxdyid: item.jxdyid,
          jxnrbt: e.jxnrbt,
          jxnrid: e.jxnrid,
          qtjxnr: e.qtjxnr
        })
      }
    })
  })
  const options = {
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/baocunjiaoshijiaoxuejihua',
    data: {
      dbgzid: parms.value.dbgzid,
      bjid: bjid.value,
      kcid: kcid.value,
      listXqjxjh: arr.map((item) => ({
        id: item.id,
        zc: item.zc,
        xq: item.xq,
        jc: item.jc,
        rq: item.rq,
        jxdyid: item.jxdyid,
        jxnrid: item.jxnrid,
        jxnrbt: item.jxnrbt,
        qtjxnr: item.qtjxnr,
        sx: item.sx
      }))
    }
  }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      closeWindow('openJiaoXueJiHua', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}

// 提交
const submitFormTj = async () => {
  // step3: 两个数组嵌套循环，根据相同的index生成一个新的数组
  const arr = []
  neirongList.value.forEach((e, i) => {
    gudingList.value.forEach((item, ind) => {
      if (i === ind) {
        arr.push({
          id: item.id,
          jc: item.jc,
          rq: item.rq,
          sx: item.sx,
          xq: item.xq,
          zc: item.zc,
          xqid: item.xqid,
          bjid: item.bjid,
          jsid: item.jsid,
          kcid: item.kcid,
          jxcdid: item.jxcdid,
          jxcdmc: item.jxcdmc,
          jxdyid: item.jxdyid,
          jxnrbt: e.jxnrbt,
          jxnrid: e.jxnrid,
          qtjxnr: e.qtjxnr
        })
      }
    })
  })
  const options = {
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/tijiaojiaoshijiaoxuejihua',
    data: {
      dbid: parms.value.id,
      bjid: bjid.value,
      kcid: kcid.value,
      listXqjxjh: arr.map((item) => ({
        id: item.id,
        zc: item.zc,
        xq: item.xq,
        jc: item.jc,
        sx: item.sx,
        jxdyid: item.jxdyid,
        jxnrid: item.jxnrid,
        jxnrbt: item.jxnrbt,
        qtjxnr: item.qtjxnr
      }))
    }
  }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      closeWindow('openJiaoXueJiHua', emits, true)
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
